import { createSelector } from '@reduxjs/toolkit';

export const selectModules = (state) => state.modules.modules;
export const selectModulesLookup = (state) => state.modules.modulesLookup;

export const selectAddModuleStatus = (state) => state.modules.addStatus;

export const selectGetModulesStatus = (state) => state.modules.getStatus;

export const selectEditModuleStatus = (state) => state.modules.editStatus;

export const selectDeleteModuleStatus = (state) => state.modules.deleteStatus;

export const selectAddModuleErrorInfo = (state) => state.modules.addError;

export const selectGetModulesErrorInfo = (state) => state.modules.getError;

export const selectEditModuleErrorInfo = (state) => state.modules.editError;

export const selectDeleteModuleErrorInfo = (state) => state.modules.deleteError;

export const selectEditedModule = (state) => state.modules.editedModule;

export const selectMemoizedEditedModule = createSelector([selectEditedModule], (editedModule) => {
    return editedModule;
});

export const selectFullModulePath = (moduleId) => (state) => {
    if (!moduleId || !state.modules.modulesLookup || !state.modules.modulesLookup[moduleId]) {
        return null;
    }

    return state.modules.modulesLookup[moduleId]['path'].toUpperCase();
};
